import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
// import { useNavigate } from "react-router-dom";
import allImgPaths from "../../assets";
import { IconButton } from "../../components";
import Button from "../../components/controls/Button";
import TextBox from "../../components/controls/TextBox";
import { useAppState } from "../../context";
import { LoginFormSchema } from "../../validations";

const Login = () => {
  // const navigate = useNavigate();
  // const { isLoggedIn, isLoading, checkLoginUser } = useAppState("auth");
  const { isLoading, checkLoginUser } = useAppState("auth");

  const [showPassword, setShowPassword] = useState(false);

  const {
    handleSubmit,
    setError,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      userName: "",
      password: "",
      invalidInput: "",
    },
    mode: "all",
    reValidateMode: "onChange",
    resolver: yupResolver(LoginFormSchema),
  });

  console.log("errors => ", errors);

  // useEffect(() => {
  //   if (isLoggedIn) {
  //     navigate("/dashboard");
  //   }
  // }, [isLoggedIn]);

  const onSubmit = (data: any) => {
    // const password = encryptPass(data.password);

    if (checkLoginUser(data.userName, data.password)) {
      // setLoginUser();
    } else {
      setError("invalidInput", {
        type: "custom",
        message: "Invalid Username and password input",
      });
    }
  };

  return (
    <form
      className="w-full bg-white border rounded-lg border-[#1c1c2c] border-opacity-25 px-3 py-[45px] mb-4"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="">
        <label htmlFor="" className="font-medium">
          Username <span className="text-[red]">*</span>
        </label>
        <div>
          <TextBox
            label="Enter User Name"
            name="userName"
            control={control}
            errors={errors}
          />
        </div>
        <div className="my-4">
          <label htmlFor="" className="font-medium">
            Password <span className="text-[red]">*</span>
          </label>
          <div className="relative">
            <TextBox
              label="Enter Password "
              name="password"
              type={showPassword ? "text" : "password"}
              min={8}
              maxLength={16}
              control={control}
              errors={errors}
            />
            <div className="absolute right-[13px] top-[8px] text-sm">
              {
                <IconButton
                  icon={
                    showPassword ? allImgPaths.eyeOpen : allImgPaths.eyeClose
                  }
                  type={"button"}
                  className="bg-[#1c1c2c] bg-opacity-0 mb-5"
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                />
              }
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center mt-6 gap-7">
        <div className="w-full">
          <Button variant="contained" type="submit" className="!w-full">
            {isLoading ? "Loading..." : "Login"}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default Login;
